/* @flow */

import * as React from "react";
import * as _ from "lodash";
import CountryUtil from "shared/src/uidispatcherapi/CountryUtil";

type Props = {};

// declare the web component for TypeScript
declare global {
    namespace JSX {
        interface IntrinsicElements {
            "cms-product-category-content": any;
        }
    }
}

export class CategoryContentPanel extends React.Component<Props> {
    constructor(props: Props) {
        super(props);
    }

    componentDidMount() {
        const siteCoreBaseUrl = _.get(
            CountryUtil.getOptionalConfig(),
            "siteCoreBaseUrl",
            "https://www-dev2-sc.metro.fr"
        );
        const script = document.createElement("script");
        script.src = `${siteCoreBaseUrl}/data/apps/content?sc_device=webcomponent&components=product-category-content`;

        if (document.head) {
            document.head.appendChild(script);
        }
    }

    render() {
        return <cms-product-category-content />;
    }
}
